import type { ChatFontSize } from './types';

/** Оформление размера шрифта ленты */
type ChatFontSizeView = {
  /** Ключ перевода подписи варианта в перечне размеров */
  labelKey: string;
  /** Класс текста ленты этого размера — им же набрана подпись варианта */
  textClassName: string;
};

/** Оформление размеров шрифта ленты карточки диалога; обычный — основной размер текста интерфейса */
export const CHAT_FONT_SIZE_VIEWS = {
  small: { labelKey: 'dialogs:chatFontSize.small', textClassName: 'text-xs' },
  normal: { labelKey: 'dialogs:chatFontSize.normal', textClassName: 'text-sm' },
  large: { labelKey: 'dialogs:chatFontSize.large', textClassName: 'text-base' },
  xlarge: { labelKey: 'dialogs:chatFontSize.xlarge', textClassName: 'text-lg' },
} as const satisfies Record<ChatFontSize, ChatFontSizeView>;
